<template>
  <section id="habilidades">
    <title-vue title="Habilidades" />
    <skil-vue :skill="abilities" />
  </section>
</template>

<script>
import TitleVue from "@/components/General/Title/Title.vue";
import SkilVue from "@/components/Skills/Skil.vue";

import { ref } from "vue";

export default {
  name: "AbilityView",
  setup() {
    const abilities = ref([
      {
        href: "https://developer.mozilla.org/pt-BR/docs/Web/HTML",
        title: "HTML5",
        src: require("@/assets/icons/html.svg"),
        alt: "Logo da linguagem de marcação HTML5",
      },
      {
        href: "https://developer.mozilla.org/pt-BR/docs/Web/CSS",
        title: "CSS3",
        src: require("@/assets/icons/css.svg"),
        alt: "Logo da linguagem de estilo CSS3",
      },
      {
        href: "https://stylus-lang.com/",
        title: "Stylus",
        src: require("@/assets/icons/Stylus.svg"),
        alt: "Logo do pré-processador de estilo CSS",
      },
      {
        href: "https://developer.mozilla.org/pt-BR/docs/Web/JavaScript",
        title: "JavaScript",
        src: require("@/assets/icons/javascript.svg"),
        alt: "Logo da linguagem javascript",
      },
      {
        href: "https://www.mysql.com/",
        title: "MYSQL",
        src: require("@/assets/icons/mysql.svg"),
        alt: "Logo do SGBD MYSQL",
      },
      {
        href: "https://www.postgresql.org/",
        title: "PostgreSQL",
        src: require("@/assets/icons/postgresql-icon.svg"),
        alt: "Logo do SGBD PostgreSQL",
      },
      {
        href: "https://git-scm.com/",
        title: "Git",
        src: require("@/assets/icons/git.svg"),
        alt: "Logo do sistema de controle de versões Git",
      },
      {
        href: "https://github.com/",
        title: "Github",
        src: require("@/assets/icons/github.svg"),
        alt: "Logo da plataforma de hospedagem github de código-fonte e arquivos com controle de versão",
      },
      {
        href: "https://analytics.google.com/analytics/web/#/",
        title: "Vue.js",
        src: require("@/assets/icons/vue.svg"),
        alt: "Logo do framework Vue.js",
      },
    ]);
    return { abilities };
  },
  components: {
    TitleVue,
    SkilVue,
  },
};
</script>

<style scoped></style>
